var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._l(_vm.question.answers, function (answer, answerIndex) {
        return _c(
          "div",
          {
            key: answerIndex,
            staticStyle: { display: "flex", "align-items": "center" },
          },
          [
            _c("div", { staticStyle: { display: "inline-flex" } }, [
              _vm._v(_vm._s(`${answer.label}`.toLowerCase()) + "."),
            ]),
            _c("div", {
              staticStyle: { "margin-left": "4px" },
              domProps: { innerHTML: _vm._s(answer.value || "") },
            }),
            !_vm.submission.isQuestionPaper && _vm.isStudentAnswerCorrectShown
              ? _c(
                  "span",
                  {
                    staticClass: "ml-2",
                    style: {
                      color: _vm.submission.isStudentWork
                        ? "#000"
                        : _vm.isCorrect(answer.key)
                        ? "#4bca81"
                        : "#d4504c",
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.convertText(_vm.studentAnswer(answer.key))) +
                        " "
                    ),
                  ]
                )
              : _vm._e(),
          ]
        )
      }),
      !_vm.submission.isQuestionPaper &&
      !_vm.submission.isStudentWork &&
      !_vm.isCorrectHidden
        ? _c(
            "div",
            { staticClass: "mt-2" },
            [
              _c("span", { staticClass: "font-weight-medium" }, [
                _vm._v("Đáp án: "),
              ]),
              _vm._l(_vm.correctAnswer(), function (answer, answerIndex) {
                return _c("div", { key: answerIndex }, [
                  _c("span", [
                    _vm._v(_vm._s(answer.label.toLowerCase()) + "-"),
                  ]),
                  _c("span", { staticClass: "green--text" }, [
                    _vm._v(_vm._s(_vm.convertText(answer.value))),
                  ]),
                ])
              }),
            ],
            2
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }